import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import DropDownField from 'yoda-checkout-components/lib/components/CustomTags/DropDownField/DropDownField';
import BannerPreShellLoader from 'yoda-checkout-components/lib/components/PreShellLoaders/BannerPreShellLoader/BannerPreShellLoader';
import Button from 'yoda-core-components/lib/components/Button';
import { AMR_CART_GC_BANNER_ATC } from 'yoda-checkout-components/lib/common/AmrConstants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { addItemToCart, setSelectedSku } from '../../actions/GiftCardBannerAction';
import * as styles from './GiftCardBanner.css';

const cx = classNames.bind(styles);

/* wrapper component to be used whereever find best coupon is needed in the app
 * Wraps  CouponPanel and the Branded FindBestCoupon link  together
 */
export function GiftCardBanner(props) {
    const {
        productDetail: { imageUrl, dropDownValues, selectedValue, bannerText },
        actions,
    } = props;
    if (isEmpty(dropDownValues)) {
        return <BannerPreShellLoader />;
    }
    function onChange(value) {
        actions.setSelectedSku(value);
    }

    return (
        <section
            className={`${cx('giftCardBannerSection', 'noBorder')} ${dt([
                'sm:text-small',
                'text-normal',
                'pt-6',
                'px-6',
                'pb-4',
                'smMd:pb-2',
                'smMd:pt-4',
                'smOnly:px-0',
                'mdOnly:px-0',
                'smMd:mx-auto',
                'smMd:my-0',
                'mdOnly:w-1/2',
            ])}`}
            data-automation-id="at-cart-gift-card-banner"
        >
            <div
                className={` ${dt([
                    'flex',
                    'items-center',
                    'leading-[18px]',
                    'text-black',
                    'mb-1',
                ])}`}
            >
                <div
                    className={dt(['w-[197px]', 'text-base', 'leading-5'])}
                    data-automation-id="at-cart-gift-card-banner-text"
                >
                    {bannerText}
                </div>
                <div className={dt(['text-base', 'ml-auto', 'min-w-[104px]'])}>
                    <DropDownField
                        automationId="gift-card-banner-dropdown"
                        name="gift-card-banner-dropdown"
                        options={dropDownValues}
                        defaultValue="Value"
                        placeholder="Value"
                        disabledValue="Value"
                        selectedValue={selectedValue.key}
                        onChange={(e) => {
                            onChange(e.target.value);
                        }}
                    />
                </div>
            </div>
            <div
                className={` ${dt(['flex'])}`}
                data-automation-id="at-cart-gift-card-banner-img"
                id={AMR_CART_GC_BANNER_ATC}
            >
                <div className={dt(['w-[12%]', 'max-w-[48px]'])}>
                    <img className={dt(['w-full'])} src={imageUrl} alt="Gift Card" />
                </div>
                <Button
                    buttonType="Link"
                    className={dt(['ml-auto'])}
                    automationId="gift-card-banner-button"
                    onClick={actions.addItemToCart}
                >
                    Add Gift Card
                </Button>
            </div>
        </section>
    );
}

GiftCardBanner.defaultProps = {
    actions: {},
    productDetail: {},
};

GiftCardBanner.propTypes = {
    actions: PropTypes.objectOf(PropTypes.func),
    productDetail: PropTypes.objectOf(PropTypes.object),
};

const mapStateToProps = (state) => ({
    productDetail: state.giftCardBannerData,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            addItemToCart,
            setSelectedSku,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(GiftCardBanner);
